'use client';

import { cn, currencyFormatter } from '@/lib/utils';

export function CurrencyText({
  value,
  showTriangle = true,
  className,
  digits = 1,
}: {
  value: number;
  showTriangle?: boolean;
  className?: string;
  digits?: number;
}) {
  const index = value > 0 ? 2 : value < 0 ? 1 : 0;
  const sign = ['', '', '+'][index];
  const triangle = showTriangle ? ['', '▼ ', '▲ '][index] : '';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 text-xs font-semibold leading-none',
        className,
        {
          'text-[#14C784]': index === 2,
          'text-[#FF6B6B]': index === 1,
          'text-[#757575]': index === 0,
        },
      )}
    >
      {triangle}
      {sign}
      {currencyFormatter(value, {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
      })}
    </span>
  );
}
